import { Box, Typography } from "@mui/material";

import Alert from "components/shared/Alert";
import RightContent from "components/wrappers/RightContent";

import { DataTable } from "./components/DataTable";
import useDraftCustomPanel from "./useDraftCustomPanel";

export const DraftCustomPanels = () => {
  const { message } = useDraftCustomPanel();

  return (
    <RightContent>
      <Box display="flex" flexDirection="column" rowGap={3}>
        <Typography variant="h1">Draft Custom Panels</Typography>
        {!!message && (
          <Alert
            severity={
              ["delete_succeed", "ownership_transferred"].includes(message)
                ? "info"
                : "warning"
            }
            noDismiss
          >
            {message === "delete_succeed" && "Draft panel deleted successfully"}
            {message === "ownership_transferred" &&
              "Draft panel ownership has been transferred successfully"}
            {message === "delete_failed" &&
              "An error occurred. Draft panel was not deleted. Please try again or contact support."}
          </Alert>
        )}
        <DataTable />
      </Box>
    </RightContent>
  );
};
